import React, { FunctionComponent } from 'react';
import Star from '../Star';
import { concat } from '../../common/helpers/arrayHelper';
import styles from './styles.module.scss';
import { addIndex, map, times } from 'ramda';

interface IProps {
  score: number;
  variant?: 'primary' | 'secondary';
}

const ScoreStar: FunctionComponent<IProps> = ({ score, variant = 'primary' }) => {
  const primaryPercent = (score * 100) / 5;

  if (variant === 'secondary') {
    const countSecondaryPercent = (starScore: number) => {
      if (starScore >= 1) return 100;
      if (starScore < 1 && starScore > 0) return (starScore - Math.floor(starScore)) * 100;
      return 0;
    };
    const secondaryPercent = times(i => countSecondaryPercent(score - i), 5);
    return (
      <div className="d-flex flex-direction-row align-items-center">
        <span className={`mr-2 ${styles.secondaryLabel} t-16 avenir-font`}>
          {score ? score.toFixed(1) : <span className={styles.placeholder}>n/a</span>}
        </span>
        {
          addIndex(map)((percent, i) => (
            <Star percent={percent as number} variant="secondary" key={i} />
          ), secondaryPercent)
        }
      </div>
    );
  }

  return (
    <div className={concat('d-flex flex-direction-row align-items-center', !primaryPercent ? styles.disabled : '')}>
      <span className={`mr-2 ${styles.primaryLabel} t-14`}>{score ? score.toFixed(1) : 'n/a'}</span>
      <Star percent={primaryPercent} />
    </div>
  );
};

export default ScoreStar;
